import * as React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import LandscapePlaceholder from "./component/landscapePlaceholder";
import PortraitPlaceholder from "./component/portraitPlaceholder";
import SquarePlaceholder from "./component/squarePlaceholder";
import LinkPreview from "common/components/linkPreview";
import EmbeddedVideoWrapper from "./component/embeddedVideoWrapper";
import { LocationDescriptor } from "history";

const styles = require("./contentPlaceholder.scss");

interface IContentPlaceholderProps {
  data: Vingle.CardContent.MediaData[];
  targetUrl: LocationDescriptor;
  width: number;
  height: number;
}

class ContentPlaceholder extends React.PureComponent<IContentPlaceholderProps> {
  public render() {
    const { data, targetUrl, height, width } = this.props;
    const filteredImageOrVideoData: Array<
      Vingle.CardContent.ImageContentData | Vingle.CardContent.VideoContentData
    > = [];
    const filteredEmbeddedVideoData: Vingle.CardContent.EmbeddedVideoData[] = [];
    const filteredLinkData: Vingle.CardContent.LinkPreviewData[] = [];

    data.forEach(datum => {
      if (datum.type === "link-preview") {
        filteredLinkData.push(datum);
      } else if (datum.type === "embedded-video") {
        filteredEmbeddedVideoData.push(datum);
      } else {
        filteredImageOrVideoData.push(datum);
      }
    });

    let thumbnailWrapper = null;

    const firstData = data[0];
    if (firstData.type === "embedded-video") {
      return (
        <div>
          <div className={styles.template}>
            <EmbeddedVideoWrapper
              componentWidth={width}
              summaryData={filteredEmbeddedVideoData}
              targetUrl={targetUrl}
            />
          </div>
        </div>
      );
    } else if (firstData.type === "link-preview") {
      const remainPreviewCount = filteredLinkData.length - 1;
      const moreElement = (
        <div className={styles.mediaMore}>
          <Link to={targetUrl}>
            <FormattedMessage
              id={"card.mediaSummary.linkPreview.more"}
              values={{ media_count: remainPreviewCount.toString() }}
            />
          </Link>
        </div>
      );

      return (
        <div>
          <div className={styles.template}>
            <LinkPreview linkPreview={firstData} />
            {remainPreviewCount > 0 ? moreElement : null}
          </div>
        </div>
      );
    } else {
      if (
        filteredImageOrVideoData[0].width > filteredImageOrVideoData[0].height
      ) {
        // long width square
        thumbnailWrapper = (
          <LandscapePlaceholder
            componentWidth={width}
            componentHeight={height}
            summaryData={filteredImageOrVideoData}
          />
        );
      } else if (
        filteredImageOrVideoData[0].width < filteredImageOrVideoData[0].height
      ) {
        // long height square
        thumbnailWrapper = (
          <PortraitPlaceholder
            componentWidth={width}
            componentHeight={height}
            summaryData={filteredImageOrVideoData}
          />
        );
      } else {
        // square
        thumbnailWrapper = (
          <SquarePlaceholder
            componentWidth={width}
            componentHeight={height}
            summaryData={filteredImageOrVideoData}
          />
        );
      }
    }

    return (
      <div className={styles.template}>
        <Link to={targetUrl}>{thumbnailWrapper}</Link>
      </div>
    );
  }
}
export default ContentPlaceholder;
